import { useAuth } from "@/contexts/AuthContext";

/**
 * Resolves which account's data the current user should request.
 * - Admins: follow the global `viewAs` selection ("all" or a specific account id).
 * - Customers: always their own account (no account_id sent).
 */
export function useDataScope() {
  const { isAdmin, viewAs } = useAuth();
  const accountId = isAdmin ? viewAs || "all" : null;
  const allMode = isAdmin && accountId === "all";
  const param = accountId ? `account_id=${encodeURIComponent(accountId)}` : "";
  return { accountId, allMode, param, isAdmin };
}
